import React, { PureComponent } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Select, SelectLabel } from "../../styled-components/";
import LuciPropTypes from "../../propTypes/";
import localize from "../../util/localizeUtils";

const PrimeSelectList = styled.div`
  align-self: center;
`;

class PrimeStyleSelect extends PureComponent {
  onChange = e => {
    this.props.onChange(e.target.value);
  };

  render() {
    const { primeStyles, onChanged } = this.props;
    return (
      <PrimeSelectList>
        <SelectLabel htmlFor="primeStyleSelect">
          {localize("primeStylesLabel")}
        </SelectLabel>
        <Select
          height="1.25rem"
          value={this.props.selectedStyle}
          id="primeStyleSelect"
          labelPadding="5.75rem"
          onChange={this.onChange}
        >
          <option key="0-none" value="">
            None
          </option>
          {primeStyles.map(style => (
            <option key={style.id} value={style.name}>
              {style.name}
            </option>
          ))}
        </Select>
      </PrimeSelectList>
    );
  }
}

PrimeStyleSelect.defaultProps = {
  selectedStyle: "",
  onChange: () => {},
  primeStyles: []
};

PrimeStyleSelect.propTypes = {
  primeStyles: PropTypes.arrayOf(LuciPropTypes.PrimeStyle),
  selectedStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func
};

export default PrimeStyleSelect;



// WEBPACK FOOTER //
// ./app/components/Editor/PrimeStyleSelect.js